module.exports = __webpack_public_path__ + "static/media/key-1.c2bb4937.svg";